// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__dP0fa","paramInput":"JobSimulator_paramInput__330if","input":"JobSimulator_input__HMLIP"};